import { render, staticRenderFns } from "./_base-subCard.vue?vue&type=template&id=a8f436a0&scoped=true"
import script from "./_base-subCard.vue?vue&type=script&lang=js"
export * from "./_base-subCard.vue?vue&type=script&lang=js"
import style0 from "./_base-subCard.vue?vue&type=style&index=0&id=a8f436a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f436a0",
  null
  
)

export default component.exports